export const ru = {
  nav: {
    links: [
      { href: "#tech", label: "Технология" },
      { href: "#cases", label: "Сценарии" },
      { href: "#roi", label: "ROI" },
      { href: "#team", label: "Команда" },
      { href: "#contact", label: "Контакты" },
    ],
    demoBtn: "Запросить демо",
  },
  hero: {
    badgeResident: "Резидент",
    badgeNvidia: "NVIDIA Inception Member",
    badgePatent: "Запатентованная технология",
    headlinePart1: "Катализатор для вашей",
    headlineGlow: "ИИ-инфраструктуры:",
    headlinePart2: "утилизация GPU",
    headlineUtil: "до 85%",
    subheadline:
      "Перестаньте сжигать 60% бюджета на простаивающем «железе». InBoost использует обучение с подкреплением (RL) и графовые нейросети (GNN), чтобы математически точно стыковать задачи с ресурсами в реальном времени.",
    ctaDemo: "Запросить демо",
    ctaRoi: "Рассчитать ROI",
    trustStrip: [
      "Повышение ёмкости дата-центра",
      "Production-grade на Kubernetes",
      "Запатентованная технология",
    ],
    graphLabel: "Bipartite Matching · RT",
    graphLive: "LIVE",
    graphFormula: "Σ Score = КЭИ × (1 − ЗКЗ) → policy:",
  },
  crisis: {
    sectionNum: "/ 01 — Кризис инфраструктуры",
    headlinePart1: "Ваш ИИ-кластер",
    headlinePart2: "работает в треть силы.",
    subtext:
      "Стандартный планировщик Kubernetes не понимает физики GPU. Он видит «карту» — не задачу. Результат — миллионы долларов, сожжённые на простоях H100 и H200.",
    stats: [
      {
        value: 35,
        title: "Средняя утилизация GPU",
        body: "Реальный показатель Enterprise-кластеров на стандартном планировщике Kubernetes.",
        accent: "#E11D48",
      },
      {
        value: 67,
        title: "Доля бюджета впустую",
        body: "Уходит из-за фрагментации памяти, неоптимальных аллокаций и простаивающих SM-юнитов.",
        accent: "#E0A800",
      },
      {
        value: 53,
        title: "Потенциал снижения TCO",
        body: "С внедрением InBoost AI Engine на существующем парке GPU — без замены оборудования.",
        accent: "#0099C9",
      },
    ],
  },
  techCore: {
    sectionNum: "/ 02 — Технологическое ядро",
    headlinePart1: "«Вычислительный дарвинизм»",
    headlinePart2: "для Kubernetes.",
    subtext:
      "Мы заменяем стандартный планировщик интеллектуальным ядром на базе RL + GNN. Каждая задача и каждый GPU получают вес — выживает сильнейшее назначение.",
    scoringTitle: "Scoring Function",
    formula: {
      left: "Score =",
      cei: "КЭИ",
      mul: "× (1 −",
      zcr: "ЗКЗ",
      right: ")",
    },
    factors: {
      ceiTitle: "КЭИ · Коэффициент эффективности",
      ceiDesc:
        "Замеряет реальную физику железа: T_test / T_actual. Учитывает PCIe, тепловой троттлинг, NVLink-топологию.",
      zcrTitle: "ЗКЗ · Зональная конкуренция за ресурсы",
      zcrDesc:
        "Управляет загрузкой зон кластера, предотвращает фрагментацию инфраструктуры.",
    },
    agentTitle: "RL-агент",
    agentSub: "Reinforcement Learning",
    agentDesc:
      "Политика обучается на исторической телеметрии DCGM и непрерывно адаптируется к нагрузке. Reward = пропускная способность × энергоэффективность.",
    gnnTitle: "GNN-эмбеддинг",
    gnnSub: "Graph Neural Network",
    gnnDesc:
      "Кодирует кластер как взвешенный двудольный граф «задача ↔ ресурс» с учётом NUMA, NVLink* и сетевой топологии.",
  },
  useCases: {
    sectionNum: "/ 03 — Экономический эффект",
    headlinePart1: "Три сценария,",
    headlinePart2: "которые меняют экономику.",
    cases: [
      {
        id: "case-hetero",
        title: "Гетерогенные кластеры",
        overline: "Hardware Mix",
        body: "Используйте потребительские карты RTX* 4090 / 5090 с производительностью серверных решений — в 5 раз дешевле. InBoost сглаживает разницу архитектур и мультивендоров — NVIDIA*, AMD*, отечественные ускорители работают в едином пуле.",
        badge: "Мультивендорность · 5× дешевле",
        color: "#0099C9",
      },
      {
        id: "case-finops",
        title: "FinOps & Billing",
        overline: "Cost Governance",
        body: "Полный контроль затрат бизнес-юнитов, предиктивное планирование закупок и автоматическое квотирование. Атрибуция стоимости до уровня pod.",
        badge: "−53% TCO",
        color: "#0050E6",
      },
      {
        id: "case-integration",
        title: "Корпоративная интеграция",
        overline: "Enterprise Stack",
        body: "Многоуровневая интеграция с корпоративными системами — ERP, CRM, BI, Billing — и DCIM-платформами дата-центра. Единый источник правды по нагрузке, затратам и SLA.",
        badge: "ERP · CRM · BI · DCIM",
        color: "#00B85A",
      },
    ],
  },
  beforeAfter: {
    sectionNum: "/ 04 — Эффект: до и после",
    headlinePart1: "Один и тот же кластер.",
    headlinePart2: "Два разных бизнеса.",
    headlinePart3: "Стек технологий.",
    beforeLabel: "Стандартный K8s*",
    beforeNote: "Default scheduler",
    beforeItems: [
      "Аллокации без учёта физики железа",
      "Фрагментация памяти HBM, простой SM-юнитов",
      "Хаотичные очереди, нарушение SLA",
      "Высокие счета за облако и электричество",
    ],
    afterLabel: "InBoost AI Engine",
    afterNote: "RL + GNN scheduler",
    afterItems: [
      "Назначения с argmax(КЭИ × (1 − ЗКЗ))",
      "Плотная упаковка MIG*-партиций и NVLink*-групп",
      "Предиктивный шедулинг, гарантия SLA",
      "Снижение TCO до 53% без замены железа",
    ],
    evolutionOverline: "Эволюция планировщиков · InBoost закрывает разрыв",
    evolutionTitle: "От слепых аллокаций — к AI-оркестрации.",
    tiers: [
      {
        tier: "K8s*",
        level: "Blind",
        desc: "Стандартный планировщик. Не видит физики железа — назначения наугад.",
        color: "#E11D48",
      },
      {
        tier: "Run:AI* (NVIDIA* KAI) / Volcano.sh*",
        level: "Rule-based optimization",
        desc: "Правила и приоритеты вручную. Лучше, чем default — но без понимания нагрузки.",
        color: "#E0A800",
      },
      {
        tier: "InBoost AI",
        level: "AI-based optimization",
        desc: "RL + GNN на телеметрии DCGM. Самооптимизация в реальном времени.",
        color: "#0050E6",
        dotColor: "#0099C9",
        highlight: true,
      },
    ],
  },
  socialProof: {
    sectionNum: "/ 05 — Доказательства",
    headlinePart1: "Числа для вашего",
    headlinePart2: "CFO.",
    caseStudyTag: "Case study · Production cluster",
    caseValue: "$13.3M",
    casePerYear: "/ год",
    caseDesc:
      "Экономия для кластера на 1024 GPU за счёт повышения утилизации с 38% до 84% и устранения фрагментации памяти HBM.",
    stats: [
      ["1024", "GPU"],
      ["84%", "UTIL"],
      ["6 мес", "PAYBACK"],
    ],
    proofs: [
      {
        id: "proof-throughput",
        title: "Рост пропускной способности",
        value: "2.5×",
        body: "Инференс LLM на существующем парке без апгрейда GPU.",
      },
      {
        id: "proof-patents",
        title: "Запатентованная технология",
        value: "DeepTech Research",
        body: "На технологии InBoost поданы международные патенты.",
      },
      {
        id: "proof-mcp",
        title: "Интеграция MCP",
        value: "Native",
        body: "Управление инфраструктурой автономными ИИ-агентами по Model Context Protocol.",
      },
    ],
    partnersHeader: "Совместимость и партнёрства",
  },
  videos: {
    sectionNum: "/ 06 — Видео",
    headlinePart1: "Платформа",
    headlinePart2: "в действии.",
    desc: "Запись обзорного питча и техническая демонстрация InBoost AI Engine — как RL-агент перераспределяет нагрузку GPU в реальном времени.",
    items: [
      {
        src: "https://rutube.ru/play/embed/3bcbcfa4362233a496378a19b80d833b/",
        title: "InBoost AI Engine — обзор платформы",
        label: "Обзор",
        provider: "RUTUBE",
      },
      {
        src: "https://rutube.ru/play/embed/7551871a26822f5a956ca38601d185b2/",
        title: "InBoost AI Engine — техническая демонстрация",
        label: "Демонстрация",
        provider: "RUTUBE",
      },
    ],
  },
  partners: {
    sectionNum: "/ 07 — Партнёрства",
    headlinePart1: "Технологические альянсы,",
    headlinePart2: "которые масштабируют внедрение.",
    desc: "Совместная разработка, интеграция и поставка решений с лидерами инфраструктурного рынка, GPU-серверов и DCIM-систем.",
  },
  roi: {
    sectionNum: "/ 08 — Калькулятор ROI",
    headlinePart1: "Сколько вы теряете",
    headlinePart2: "каждый час?",
    desc: "Двигайте параметры — расчёт обновляется в реальном времени. Серверный расчёт учитывает амортизацию, электричество и эффект MIG-партиций.",
    gpuCountLabel: "Количество GPU",
    gpuCountUnit: "карт",
    gpuCountHint: "16 → 4096",
    utilLabel: "Текущая утилизация GPU",
    utilHint: "10% → 80%",
    costLabel: "Средняя стоимость GPU-часа",
    costUnit: "/ час",
    costHint: "$0.50 → $6.00",
    computeBtn: "Точный расчёт",
    computeBtnLoading: "Считаем…",
    resultAnnualSavings: "Annual Savings",
    resultFleetNote: "на текущем парке GPU",
    resultUtilTarget: "Util target",
    resultCapacityUnlock: "Capacity unlock",
    ctaFullReport: "Получить детальный отчёт →",
  },
  team: {
    sectionNum: "/ 09 — Команда",
    headlinePart1: "Архитекторы железа.",
    headlinePart2: "Один продукт.",
    members: [
      {
        name: "Ольга Андрианова",
        role: "CEO & Co-founder",
        bullets: [
          "17 лет в Intel — лидерство в Enterprise-направлении",
          "Экс-директор ИИ-проектов Сбера",
          "Эксперт по B2B-продажам в Европе и РФ",
        ],
        tag: "ex-Intel · ex-Sber",
      },
      {
        name: "Дмитрий Букод",
        role: "CTO & Co-founder",
        bullets: [
          "20 лет в Intel — архитектура систем оптимизации HW/SW",
          "Кандидат физико-математических наук",
          "Автор 3 международных патентов",
        ],
        tag: "ex-Intel · к.ф.-м.н.",
      },
      {
        name: "Андрей",
        role: "CPO",
        bullets: [
          "10+ лет в международном BigTech и стартапах",
          "Запуск продуктов на рынки EMEA и APAC",
          "Product strategy для Deep Tech и Enterprise",
        ],
        tag: "BigTech · ex-Startups",
      },
      {
        name: "Максим Маслов",
        role: "Advisor · Бизнес-ангел",
        bullets: [
          "Co-founder & CTO — Eltechs (deep-tech startup)",
          "Huawei (3 года) — Архитектор",
          "Baikal Electronics, группа «Астра» — GPU Architect",
        ],
        tag: "ex-Eltechs · Baikal",
      },
      {
        name: "Антон Шоколов",
        role: "AI Research & Engineering",
        bullets: [
          "Новосибирский государственный университет",
          "Исследования в ИИ и разработке ПО",
        ],
        tag: "NSU · AI Research",
      },
    ],
  },
  quizCta: {
    badge: "5 вопросов · 60 секунд",
    headlinePart1: "Узнайте потенциал",
    headlinePart2: "внедрения за минуту.",
    desc: "Ответьте на 5 коротких вопросов о вашей инфраструктуре — получите индивидуальный отчёт с оценкой готовности и сценарием пилота.",
    btnQuiz: "Пройти квиз",
    btnRoi: "Калькулятор ROI",
    deliverablesHeader: "Что вы получите",
    deliverables: [
      "Оценка готовности кластера к оркестрации",
      "Прогноз экономии в долларах за год",
      "Сценарий пилота на 30 дней",
      "Сравнение с лучшими практиками индустрии",
    ],
  },
  quizModal: {
    title: "Оценка потенциала InBoost",
    subtitle: "5 вопросов · ~60 секунд",
    stepContact: "Шаг 6 · Контакты",
    stepCounter: (step, total) => `Шаг ${step + 1} / ${total}`,
    contactHeader: "Куда отправить детальный расчёт?",
    contactDesc: "Мы подготовим персонализированный отчёт с графиком внедрения и прогнозом экономии.",
    fieldCompany: "Компания *",
    fieldName: "Ваше имя *",
    fieldEmail: "Рабочий Email *",
    btnSubmit: "Получить персональный отчёт",
    btnSubmitting: "Отправляем…",
    successTitle: "Оценка сформирована!",
    successReady: "Высокая готовность к оптимизации",
    successDesc: "Мы получили ваши ответы и подготовим детальный отчёт со сценарием пилота на 30 дней.",
    btnDemo: "Запросить демо встречу",
    btnClose: "Закрыть",
  },
  demoModal: {
    title: "Запросить демо InBoost",
    subtitle: "30-минутный технический брифинг",
    fieldName: "Имя *",
    fieldCompany: "Компания *",
    fieldEmail: "Рабочий Email *",
    fieldPhone: "Телефон",
    fieldGpu: "Количество GPU",
    fieldGpuPlaceholder: "напр. 256",
    fieldMessage: "Сообщение",
    fieldMessagePlaceholder: "Опишите задачу или нагрузку — H100, RTX 5090, тип воркфлоу…",
    btnSubmit: "Отправить заявку",
    btnSubmitting: "Отправляем…",
    successTitle: "Спасибо!",
    successDesc: "Мы получили заявку и свяжемся с вами в течение 24 часов для согласования времени встречи.",
    btnClose: "Закрыть",
  },
  footer: {
    taglinePart1: "Закрываем разрыв между",
    taglineCyan: "бизнес-целями",
    taglinePart2: "и",
    taglineMuted: "реальностью железа.",
    badgePatent: "Запатентованная технология",
    contactsTitle: "Контакты",
    notice:
      "Сайт носит информационный характер и не использует формы сбора персональных данных пользователей. По вопросам обработки персональных данных ознакомьтесь с Политикой обработки персональных данных. По правовым вопросам ознакомьтесь с Правовой информацией.",
    privacyLink: "Политика ПДн",
    legalLink: "Правовая информация",
    copyright: "ООО «ИнБуст» · InBoost AI Engine. Все права защищены.",
    madeIn: "Сделано в Москве · v1.0",
    trademarks:
      "* Названия и логотипы продуктов и технологий (Kubernetes, K8s, NVIDIA, RTX, NVLink, DCGM, MIG, Run:AI, NVIDIA KAI, Volcano.sh и др.) являются товарными знаками или зарегистрированными товарными знаками соответствующих правообладателей.",
  },
};
